import { ClosingFormValues } from "../FinancialClosingDetails";
import { FormikErrors } from "formik";

export const scrollToTheFirstClosingError = (
  errors: FormikErrors<ClosingFormValues>,
  financialClosing: ClosingFormValues
) => {
  const firstCheckListError = Array.isArray(errors.checklist_items)
    ? errors.checklist_items.findIndex((error) => error !== undefined)
    : -1;

  const firstCheckListErrorId =
    firstCheckListError && firstCheckListError > 0
      ? financialClosing.checklist_items[firstCheckListError].uuid
      : null;

  const firstOtherFinancialError = Array.isArray(errors.other_financials)
    ? errors.other_financials.findIndex(
        (error) =>
          typeof error === "object" &&
          error !== null &&
          (error.document || error.document_name)
      )
    : -1;

  if (firstCheckListError >= 0) {
    const element = document.getElementById(firstCheckListErrorId!);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
      element.focus();
    }
  }

  if (firstOtherFinancialError >= 0) {
    const otherFinancialError =
      errors.other_financials?.[firstOtherFinancialError];
    const documentError =
      typeof otherFinancialError === "object" && otherFinancialError !== null
        ? otherFinancialError.document
        : undefined;
    const documentNameError =
      typeof otherFinancialError === "object" && otherFinancialError !== null
        ? otherFinancialError.document_name
        : undefined;

    const documentErrorName = `other_financials[${firstOtherFinancialError}].document`;
    const documentNameErrorName = `other_financials[${firstOtherFinancialError}].document_name`;

    if (documentError || documentNameError) {
      const element = document.getElementsByName(
        documentError ? documentErrorName : documentNameErrorName
      )?.[0];

      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
    }
  }

  if (errors.accounting_lock_date) {
    const element = document.getElementById("accounting_lock_date");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
      element.focus();
    }
  }
};
